export class Slot {
    id: number;
    title: String;
    start: Date;
    end: Date;
    color: string;
    price: number;
}
